import React from 'react';

import { useLocation } from 'react-router-dom';

import { ReactComponent as TwitterIcon } from '@pkg/assets/icons/v2/social/twitter.svg';
import { DepButton, DepButtonDisplay } from '@pkg/components/deprecated';

import { callProviderAuth } from '@app/client/resources/w3auth';
import { AuthProviders } from '@app/client/resources/w3auth/types';
import SystemRedirect, { RedirectType } from '@app/helpers/classes/Redirect';

import { Typography } from '../DesignSystem';

import { FantasyLineupIllustration } from './FantasyLineupIllustration';

import { ButtonIcon, Container, PrimaryCopySection, Section } from './styles';

export function AddTwitter() {
    const location = useLocation();

    async function handleConnectTwitterClick() {
        const link = await callProviderAuth(AuthProviders.Twitter);
        if (link) {
            SystemRedirect.setRedirect(RedirectType.Default, location.pathname);
            window.location.href = link;
        }
    }

    return (
        <Container>
            <Section>
                <FantasyLineupIllustration />
            </Section>
            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Make it easier for friends to find you
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    Connect your Twitter to display your username across Pods, Yat Fantasy, NFTs, and more.
                </Typography>
            </PrimaryCopySection>
            <Section>
                <DepButton
                    variant="primary"
                    glow
                    display={DepButtonDisplay.minWidth}
                    onClick={handleConnectTwitterClick}
                >
                    <ButtonIcon>
                        <TwitterIcon />
                    </ButtonIcon>{' '}
                    Connect Twitter
                </DepButton>
            </Section>
        </Container>
    );
}
